import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { LogoMark } from "@/components/Logo";

const prettyTime = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const am = h < 12;
  return `${(h + 11) % 12 + 1}:${String(m).padStart(2, "0")} ${am ? "AM" : "PM"}`;
};

const prettyDate = (d) => {
  if (!d) return "";
  return new Date(`${d}T12:00:00`).toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
};

export default function ThankYouPage() {
  const [params] = useSearchParams();
  const type = params.get("type") || "full";
  const date = params.get("date") || "";
  const time = params.get("time") || "";
  const isConsultation = type === "consultation";
  const portalToken = sessionStorage.getItem("aih_portal_token") || "";

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-5 py-24 grain">
      <div className="max-w-xl w-full text-center rounded-3xl border border-emerald-500/25 bg-obsidian-800/70 p-10 sm:p-14">
        <div className="flex justify-center mb-6">
          <LogoMark className="w-14 h-14" />
        </div>
        <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto" />
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-white mt-6" data-testid="thankyou-heading">
          You're all set
        </h1>
        <p className="text-slate-400 mt-4 leading-relaxed" data-testid="thankyou-sub">
          {isConsultation ? "Your consultation request is in." : "Your intake is complete and your session is booked."}
        </p>

        {date && time && (
          <div
            data-testid="thankyou-booking-summary"
            className="mt-8 rounded-2xl border border-gold/25 bg-obsidian-900/60 px-6 py-5"
          >
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">
              {isConsultation ? "Consultation" : "Strategy session"}
            </p>
            <p className="font-display font-bold text-white mt-2">
              {prettyDate(date)} · {prettyTime(time)}
            </p>
          </div>
        )}

        {portalToken && (
          <Link
            to={`/portal?token=${encodeURIComponent(portalToken)}`}
            data-testid="thankyou-portal-link"
            className="block mt-8 w-full rounded-full bg-gold text-obsidian font-display font-bold py-4 hover:bg-gold-bright transition-colors"
          >
            Open My All In Hand Portal
          </Link>
        )}

        <div className="mt-9 text-left space-y-3">
          {[
            "We review your current digital position and objectives.",
            "You receive recommended priorities based on the agreed scope.",
            "You decide which services, if any, you want to purchase.",
          ].map((s, i) => (
            <div key={s} className="flex gap-3 items-center text-sm text-slate-300">
              <span className="font-mono text-[10px] text-emerald-400 w-5 h-5 rounded-full border border-emerald-500/40 flex items-center justify-center shrink-0">
                {i + 1}
              </span>
              {s}
            </div>
          ))}
        </div>

        <Link
          data-testid="thankyou-home-link"
          to="/"
          className="inline-block mt-10 rounded-full border border-gold/60 text-gold font-display font-bold px-8 py-3.5 hover:bg-gold hover:text-obsidian transition-colors"
        >
          Back to All In Hand Marketing
        </Link>
      </div>
    </div>
  );
}
